var exports = {
  "kL": "x61f99309--ba591b--container",
  "wG": "x61f99309--ba591b--loader",
  "uW": "x61f99309--ba591b--circle-spin",
  "iq": "x61f99309--ba591b--cancel_button",
  "vP": "x61f99309--ba591b--icon_button",
};

module.exports = exports;
